import { createAction } from '@reduxjs/toolkit'
import type { Middleware } from '@reduxjs/toolkit'
import TabsSync from '@/services/TabsSync/TabsSync'
import { TabsSyncMessages } from '@/services/TabsSync/constants'
import { clearSession } from '@/utils/auth/clearSession'
import { restoreSession } from '@/utils/auth/restoreSession'
import type { AppDispatch, RootState } from '../types'

/**
 * Signal actions dispatched locally. They have no reducer — the middleware
 * catches them and broadcasts the corresponding event to the other tabs.
 */
export const broadcastLogout = createAction('tabsSync/broadcastLogout')
export const broadcastLogin = createAction('tabsSync/broadcastLogin')

export const createTabsSyncMiddleware = (): Middleware => (store) => {
  const tabsSync = new TabsSync()

  tabsSync.addEventListener(TabsSyncMessages.Logout, () => {
    clearSession(store.dispatch as AppDispatch)
  })

  tabsSync.addEventListener(TabsSyncMessages.Login, () => {
    if (!(store.getState() as RootState).user.user) {
      restoreSession(store.dispatch as AppDispatch)
    }
  })

  return (next) => (action) => {
    const result = next(action)
    if (broadcastLogout.match(action)) {
      tabsSync.send(TabsSyncMessages.Logout)
    } else if (broadcastLogin.match(action)) {
      tabsSync.send(TabsSyncMessages.Login)
    }
    return result
  }
}
